require('./bootstrap');


import Vue from 'vue';
import VueRouter from 'vue-router';

import router from './Router/index';
import store from './Store/index';
import App from './App.vue';
import VueSocialSharing from 'vue-social-sharing';
import Croppa from 'vue-croppa';
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
Vue.use(Croppa);
Vue.use(VueRouter)
Vue.use(require('vue-moment'));
Vue.use(VueSocialSharing);

window.Swal = require('sweetalert2');
// home page 2
Vue.component('navbar2', require('./Layouts/Navbar2').default);
Vue.component('month-component', require('./Components/MonthComponent').default);
// home page 2
Vue.component('navbar', require('./Layouts/Navbar').default);
Vue.component('map-component', require('./Components/MapComponent').default);
Vue.component('newsletter-component', require('./Components/NewsletterComponent').default);
Vue.component('footer-component', require('./Components/FooterComponent').default);
Vue.component('slide-show-component', require('./Components/SlideShowComponent').default);


Vue.component('category-index', require('./Components/CategoryIndex').default);
Vue.component('category-show', require('./Components/CategoryShow').default);

Vue.component('region-component', require('./Components/RegionComponent').default);
Vue.component('region-index', require('./Components/RegionIndex').default);

Vue.component('speakers-component', require('./Components/SpeakersComponent').default);
Vue.component('speaker-show', require('./Components/SpeakerShow').default);

Vue.component('event-component', require('./Components/EventComponent').default);
Vue.component('event-show', require('./Components/EventShow').default);
Vue.component('filter-component', require('./Components/FilterComponent').default);
Vue.component('related-component', require('./Components/RelatedComponent').default);

// import Toasted from 'vue-toasted';
// Vue.use(Toasted, {
//   duration: 1500,
//   position: 'bottom-right',
//   theme: 'bubble',
//   type: 'success',
// })

const app = new Vue({
    el: '#app',
    router,
    store,
    components: {App}
});